// extracted by mini-css-extract-plugin
export default {"newTabToast":"toasters__newTabToast___1Ek9+"};